/**
 * Documentos que um contrato pode exigir (D28/D30, 19/10/2026).
 *
 * Fonte única para o Setup (o que se configura) e para os apps (o que se envia).
 * Antes eram duas listas, e os apps não tinham "Termo de Ciencia Beneficiario"
 * nem o TRCT: um contrato que os exigia não tinha como recebê-los.
 */
export const DOCUMENTOS = [
  "Termo de Ciencia Beneficiario",
  "Termo de Recisão Contrato de Trabalho (TRCT)",
  "União Estável",
  "RG/CPF",
  "Certidão de Nascimento",
  "Certidão de Casamento",
  "Três últimos olerites",
  "Carta INSS",
  "Formulário Operadora",
  "Comprovante de Endereço",
  "Caderneta da Criança",
  "Carta Assinada",
  "Ficha de Registro",
  "Comprovante Vínculo Empregatício",
  "Comprovante Matrícula Faculdade",
] as const;

/**
 * Lista do upload: primeiro o que a linha exige, depois o resto. Um nome exigido
 * fora da lista (configuração antiga com grafia diferente) continua enviável.
 */
export function opcoesDeUpload(exigidos: string[] = []): string[] {
  return [...new Set([...exigidos, ...DOCUMENTOS])];
}

export function documentosFaltando(exigidos: string[] = [], enviados: string[] = []): string[] {
  return exigidos.filter((d) => !enviados.includes(d));
}
